import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import {
    ButtonSharedModule,
    IconSharedModule,
    ModalService,
    ModalSharedModule,
} from "pf_styleguide";

import { DraggableContainerDirective } from "../directive/draggable-container.directive";
import { CheckoutPopupModule } from "../shared/module/checkout-popup/checkout-popup.module";
import { MomentTimezonePipeModule } from "../shared/module/pipe/moment-timezone-pipe.module";
import { VenuePipeModule } from "../venue/venue-pipe.module";

import { CalendarComponent } from "./calendar.component";

@NgModule({
    declarations: [CalendarComponent, DraggableContainerDirective],
    imports: [
        CommonModule,
        VenuePipeModule,
        MomentTimezonePipeModule,
        ButtonSharedModule,
        IconSharedModule,
        ModalSharedModule,
        CheckoutPopupModule,
    ],
    exports: [CalendarComponent],
    providers: [ModalService],
})
export class CalendarModule {}
